(ns dashboard.html
  (:require [clojure.string :as str]))

(defn strip-markup [text]
  (when text
    (.-innerText (.-body (.parseFromString (js/DOMParser.) text "text/html")))))

(defn as-hiccup-with-anchors
  "Creates hiccup out of content, with HTTPS urls having achor elements, so that links become clickable"
  [content]
  (when content
    (into [:span.text-layout]
          (map (fn [word]
                 (if (.startsWith word "https")
                   ;; Replace HTTPS urls with anchors, so that user can click them.
                   ;; HTTPS to be pessimistic (so we don't make unsecure non-ssl links)
                   [:a
                    {:href word
                     :target "_blank"}
                    word]
                   word)))
          (-> (strip-markup content) ;; Remove any markup, so we don't end up anchor elements twice
              (str/replace #"\u00a0|\u202F|\u2007|\uFEFF|\u2060" " ") ;; Replace non-breaking spaces with spaces that allow breaking
              ;; Split by URLs
              (str/split #"(https://[^\s]+)")))))
